import type { PricingSummaryField } from './types';

export const PRICING_SUMMARY_FIELDS: Array<PricingSummaryField> = [];
